<template>
    <span v-if="logoVariant=='logoTextImgTop'" style="width:100%;">
        <v-card
        class="mx-auto mt-6 d-flex flex-column elevation-0 logoText"
        width="300"
    >
        <router-link to="/">
            <v-img
                class="logoLinkZ"
                width="200"
                :src="require(`@/assets/emmie_logo_text.png`)"
                :alt="`emmie`"
                to="/" link
            ></v-img>
        </router-link>
        <h2>{{ siteName }}</h2>
        </v-card>
    </span> 
    <v-row v-if="logoVariant=='logoImgTop'" style="width:100%;">
        <v-card
        class="mx-auto mt-6 d-flex flex-column elevation-0 logoText"
        width="300"
    >
    <div style="width: 300px; display:flex;">
        <div style="display: inline-flex; position: fixed;
    top: 30px;">
        <router-link to="/">
            <v-img
                class="logosmall logoLinkZ"
                width="50"
                :src="require(`@/assets/emmie_logo.png`)"
                :alt="`emmie`"
                to="/" link
            ></v-img>
        </router-link>
        <div style="display: inline-block; align-self: center; margin-left: 10px; font-weight: bold; font-size: 20px;">{{ siteName }}</div>
        </div>
    </div>
        
        </v-card>
    </v-row> 
</template>

<script>
import { ref, onMounted, onUnmounted, isProxy, toRef } from 'vue'
export default{
    name:"emmieSiteLogo",
    props: {
        siteName:String,
        logoVariant:String,
    },
    setup(props) {
        const siteName = toRef(props, 'siteName')
        const logoVariant = toRef(props, 'logoVariant')
        return {
            siteName,
            logoVariant,
        }
    }
    
}
</script>

<style>
.logoText{
    align-items: center;
}
.logoText h2{
    margin-top: 10px;
    font-size: 25px;
}
.logoLinkZ{
    z-index: ;
}

</style>